import { apiService } from './api';

export interface User {
    usuario_id: string;
    nome: string;
    sobrenome: string;
    email: string;
    status: string;
    documento?: string;
    telefone?: string;
    dt_ultimo_login?: string;
}

export interface UserFilters {
    nome?: string;
    email?: string;
    status?: string;
    page?: number;
    size?: number;
}

export interface UserApiResponse {
    content: User[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;
}

export interface CreateUserRequest {
    documento: string;
    nome: string;
    sobrenome: string;
    email: string;
    telefone: string;
}

export interface UpdateUserRequest {
    nome: string;
    sobrenome: string;
    telefone?: string;
    documento: string;
    email: string;
    status: string;
}

export interface UsuarioInfoPorEntidadeResponse {
    perfil: string;
    nome: string;
    permissoes: string[];
}

export interface UsuarioInfoResponse {
    nome: string;
    documento: string;
    email: string;
}

export interface UsuarioSimplificadoResponse {
    usuarioId: string;
    nome: string;
    email: string;
}

export const userService = {

    async getUsers(filters: UserFilters = {}): Promise<UserApiResponse> {
        const params = new URLSearchParams();
        if (filters.nome) params.append('nome', filters.nome);
        if (filters.email) params.append('email', filters.email);
        if (filters.status) params.append('status', filters.status);
        params.append('page', (filters.page ?? 0).toString());
        params.append('size', (filters.size ?? 10).toString());
        const url = `/usuario?${params.toString()}`;
        return apiService.get<UserApiResponse>(url);
    },

    async getActiveUsersByEntity(entidadeId: string): Promise<UsuarioSimplificadoResponse[]> {
        return apiService.get<UsuarioSimplificadoResponse[]>(`/usuario/${entidadeId}/ativos`);
    },

    async createUser(user: CreateUserRequest): Promise<User> {
        return apiService.post<User>('/usuario', user);
    },

    async getUserInfoByEntidade(entidadeId: string): Promise<UsuarioInfoPorEntidadeResponse[]> {
        return apiService.get<UsuarioInfoPorEntidadeResponse[]>(`/usuario/${entidadeId}/info`);
    },

    async getUserInfo(): Promise<UsuarioInfoResponse> {
        return apiService.get<UsuarioInfoResponse>('/usuario/info');
    },

    async getUserById(userId: string): Promise<User> {
        return apiService.get<User>(`/usuario/${userId}`);
    },

    async editUser(userId: string, userData: UpdateUserRequest): Promise<void> {
        return apiService.put<void>(`/usuario/${userId}`, userData);
    },

};